import { Box, useTheme } from "@mui/material";

import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
// import { required } from '../../utils/validation';

import { ImportStandAloneFile } from "../../theme/import/ImportStandAloneFile";


const MImportData = (props) => {
   
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    
    return(
        <SHModal
            open={props.open}
            onClose={() => props.handleClose(false)}
        >

            <ImportStandAloneFile
                logo={props.logo}
                title={props.title}
                fileType={props.fileType}
                columns={props.columns}
                notice={props.notice}
                exampleFile={props.exampleFile}
                handleClose={props.handleClose}
                importSettings={props.importSettings || null}
                onSaveSettings={props.onSaveSettings}
            />
        </SHModal>
        
    )
}

export default MImportData;
